import React from "react";
import CommonImageView from "presentational/common/CommonImageView";
import IconButtonView from "presentational/common/IconButtonView";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import TextButtonView from "presentational/common/TextButtonView";
// import GenderLocationInfoText from "presentational/common/multinational/GenderLocationInfoText";
import FollowCountText from "presentational/common/multinational/FollowCountText";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const INFO_TEXT_FONT_SIZE_OF_DESKTOP = 14;
const INFO_TEXT_FONT_SIZE_OF_MOBILE = 12;

const USERNAME_FONT_SIZE_OF_DESKTOP = 56;
const USERNAME_FONT_SIZE_OF_MOBILE = 24;

/**
 * 데스크탑에서 사용자이름이 맨 위에 있을경우
 * 사진끝과 이름 최상단의 높이를 맞추기위한 하드코딩값
 */
const USERNAME_OFFSET_FOR_ALIGN_OF_DESKTOP = 5;

/**
 * WIDTH_OF_IMAGE_AREA_FOR_DESKTOP
 * : 인포텍스트 + 사용자이름 + 버튼 상황에서의 이미지 크기
 *
 * WIDTH_OF_IMAGE_AREA_Of_WITHOUT_INFO_TEXT_FOR_DESKTOP
 * : 사용자이름 + 버튼 상황에서의 이미지 크기 (인포텍스트 빠진 화면용)
 */
const WIDTH_OF_IMAGE_AREA_FOR_DESKTOP = 140;
const WIDTH_OF_IMAGE_AREA_Of_WITHOUT_INFO_TEXT_FOR_DESKTOP = 108;
const LEFT_MARGIN_OF_TEXT_AREA_FOR_DESKTOP = 25;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const fontCss = config.css.fontThickness;
const colorCss = config.css.color;
const MORE_BTN_TYPE = config.iconDesign.moreButton;

const cssXL = {
  root: {
    marginBottom: desktopCss.standardPaddingBetweenContent,

    display: "flex",
    flexDirection: "column"
  },
  profileRow: {
    display: "flex",
    marginBottom: 15,
    alignItems: "center"
  },
  imageArea: {
    width: WIDTH_OF_IMAGE_AREA_FOR_DESKTOP,
    flexShrink: 0
  },
  imageAreaWithoutInfoText: {
    width: WIDTH_OF_IMAGE_AREA_Of_WITHOUT_INFO_TEXT_FOR_DESKTOP,
    flexShrink: 0
  },
  textArea: {
    height: WIDTH_OF_IMAGE_AREA_FOR_DESKTOP,
    width: `calc(100% - ${
      WIDTH_OF_IMAGE_AREA_FOR_DESKTOP + LEFT_MARGIN_OF_TEXT_AREA_FOR_DESKTOP
    }px)`,
    marginLeft: LEFT_MARGIN_OF_TEXT_AREA_FOR_DESKTOP,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  textAreaWithoutInfoText: {
    height: WIDTH_OF_IMAGE_AREA_Of_WITHOUT_INFO_TEXT_FOR_DESKTOP,
    width: `calc(100% - ${
      WIDTH_OF_IMAGE_AREA_Of_WITHOUT_INFO_TEXT_FOR_DESKTOP +
      LEFT_MARGIN_OF_TEXT_AREA_FOR_DESKTOP
    }px)`,
    marginLeft: LEFT_MARGIN_OF_TEXT_AREA_FOR_DESKTOP,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  iconOfButton: {
    marginRight: desktopCss.paddingBetweenTextAndIcon
  },
  textLine: {
    height: INFO_TEXT_FONT_SIZE_OF_DESKTOP,

    display: "flex",
    alignItems: "center",
    marginBottom: 5
  },
  username: {
    display: "flex",
    alignItems: "center",
    marginBottom: 5,
    height: USERNAME_FONT_SIZE_OF_DESKTOP - USERNAME_OFFSET_FOR_ALIGN_OF_DESKTOP
  },
  buttonRow: {
    display: "flex"
  },
  secondBtn: {
    paddingLeft: 15
  },
  aaaa: {}
};
const cssXS = {
  root: {
    marginTop:
      -mobileCss.paddingBetweenHeaderbarAndFirstContent +
      mobileCss.paddingBetweenHeaderbarAndFirstContentForPortfolio,
    marginBottom: mobileCss.standardPaddingBetweenContent,

    display: "flex",
    flexDirection: "column"
  },
  profileRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 20
  },
  imageArea: {
    width: 90,
    paddingBottom: 20
  },
  usernameArea: {
    paddingBottom: 7,
    width: "100%",
    display: "flex",
    justifyContent: "center"
  },
  // userInfo: { display: "flex" },
  followInfo: { display: "flex" },
  infoTextUnitFirst: {
    display: "flex",
    alignItems: "center",
    marginLeft: 0
  },
  infoTextUnit: {
    display: "flex",
    alignItems: "center",
    marginLeft: 10
  },
  infoTxtBtn: { cursor: "pointer" },
  buttonRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  firstBtn: { cursor: "pointer" },
  secondBtn: { cursor: "pointer", paddingLeft: 10 },
  iconOfButton: {
    marginRight: mobileCss.paddingBetweenTextAndIcon
  }
};

const OwnerNameTypographyXL = withStyles({
  root: {
    fontSize: USERNAME_FONT_SIZE_OF_DESKTOP,
    lineHeight: 1.2,
    fontWeight: fontCss.medium,
    overflow: "hidden",
    wordBreak: "break-all"
  }
})(Typography);
const OwnerNameTypographyXS = withStyles({
  root: {
    fontSize: USERNAME_FONT_SIZE_OF_MOBILE,
    lineHeight: 1.2,
    fontWeight: fontCss.medium,
    overflow: "hidden",
    wordBreak: "break-all",
    textAlign: "center"
  }
})(Typography);
const RelationTypographyXL = withStyles({
  root: {
    fontSize: INFO_TEXT_FONT_SIZE_OF_DESKTOP,
    display: "inline-block",
    marginRight: 15
  }
})(Typography);
const RelationTypographyXS = withStyles({
  root: {
    fontSize: INFO_TEXT_FONT_SIZE_OF_MOBILE,
    display: "inline-block"
  }
})(Typography);

ProfileUnitView.propTypes = {
  profileType: PropTypes.oneOf(["mine", "others", "demo"]).isRequired,
  ownerName: PropTypes.string.isRequired,
  followingNum: PropTypes.number,
  // location: PropTypes.string.isRequired,
  // gender: PropTypes.string.isRequired,
  image: PropTypes.string,

  onFollowUserListBtnClick: PropTypes.func,
  onMoreBtnClick: PropTypes.func,

  firstBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  firstBtnStyle: PropTypes.oneOf(["primary", "bold", "soft"]),
  disabledFirstBtn: PropTypes.bool,
  onFirstBtnClick: PropTypes.func,
  secondBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondBtnStyle: PropTypes.oneOf(["primary", "bold", "soft"]),
  disabledSecondBtn: PropTypes.bool,
  onSecondBtnClick: PropTypes.func
};

ProfileUnitView.defaultProps = {
  onFollowUserListBtnClick: () => {},
  onMoreBtnClick: () => {},
  imageUploadBtn: false,

  firstBtnStyle: "bold",
  disabledFirstBtn: false,

  secondBtnStyle: "bold",
  disabledSecondBtn: false
};

function ProfileUnitView(props) {
  const {
    profileType,
    ownerName,
    /*location,
    gender,*/
    followingNum,
    image,
    firstBtnText,
    firstBtnStyle,
    disabledFirstBtn,
    onFirstBtnClick,
    secondBtnText,
    secondBtnStyle,
    disabledSecondBtn,
    onSecondBtnClick,
    onFollowUserListBtnClick,
    onMoreBtnClick
  } = props;

  const handleFollowClick = modalType => () => {
    /** modalType으로 "follower"값은 현재 호출되지 않고 있다. */
    if (profileType === "others") return null;
    onFollowUserListBtnClick(modalType);
  };

  const mobileLayout = () => {
    const css = cssXS;
    const imageSrc = image || "pending";

    return (
      <div style={css.root}>
        <div style={css.profileRow}>
          <div style={css.imageArea}>
            <CommonImageView
              imageSrc={imageSrc}
              imageRatio={config.profileImage.RATIO}
            />
          </div>
          <div style={css.usernameArea}>
            <OwnerNameTypographyXS variant="h4">
              {ownerName}
            </OwnerNameTypographyXS>
          </div>
          {/* <div style={css.userInfo}>
            <RelationTypographyXS color="secondary">
              <GenderLocationInfoText gender={gender} location={location} />
            </RelationTypographyXS>
          </div> */}
          <div style={css.followInfo}>
            {profileType === "mine" && (
              <div style={css.infoTextUnitFirst}>
                <RelationTypographyXS
                  color="secondary"
                  style={profileType === "mine" ? css.infoTxtBtn : null}
                  onClick={handleFollowClick("following")}
                >
                  <FollowCountText type="following" number={followingNum} />
                </RelationTypographyXS>
              </div>
            )}
            {profileType === "demo" && (
              <div style={css.infoTextUnit}>
                <RelationTypographyXS color="secondary">
                  <FollowCountText type="following" number={followingNum} />
                </RelationTypographyXS>
              </div>
            )}
            {profileType === "mine" && (
              <div style={css.infoTextUnit}>
                <IconButtonView
                  type={MORE_BTN_TYPE}
                  onClick={onMoreBtnClick}
                  buttonSize={"small"}
                  fontSize={"xsForMinorText"}
                />
              </div>
            )}
          </div>
        </div>
        <div style={css.buttonRow}>
          {firstBtnText && (
            <div style={css.firstBtn}>
              <ContainedCommonButtonView
                onClick={onFirstBtnClick}
                design={firstBtnStyle}
                disabled={disabledFirstBtn}
              >
                {firstBtnText}
              </ContainedCommonButtonView>
            </div>
          )}
          {secondBtnText && (
            <div style={css.secondBtn}>
              <ContainedCommonButtonView
                onClick={onSecondBtnClick}
                design={secondBtnStyle}
                disabled={disabledSecondBtn}
              >
                {secondBtnText}
              </ContainedCommonButtonView>
            </div>
          )}
        </div>
      </div>
    );
  };

  const desktopLayout = () => {
    const css = cssXL;
    const imageSrc = image || "pending";

    return (
      <div style={css.root}>
        <div style={css.profileRow}>
          <div
            style={
              profileType === "others"
                ? css.imageAreaWithoutInfoText
                : css.imageArea
            }
          >
            <CommonImageView
              imageSrc={imageSrc}
              imageRatio={config.profileImage.RATIO}
            />
          </div>
          <div
            style={
              profileType === "others"
                ? css.textAreaWithoutInfoText
                : css.textArea
            }
          >
            {profileType === "mine" && (
              <div style={css.textLine}>
                {/* <RelationTypographyXL color="secondary">
                  <GenderLocationInfoText gender={gender} location={location} />
                </RelationTypographyXL> */}
                <TextButtonView
                  disableLeftMargin
                  fontSize={INFO_TEXT_FONT_SIZE_OF_DESKTOP}
                  fontColor={colorCss.colorOfSecondary}
                  fontWeight={fontCss.regular}
                  onClick={handleFollowClick("following")}
                >
                  <FollowCountText type="following" number={followingNum} />
                </TextButtonView>
                <IconButtonView
                  type={MORE_BTN_TYPE}
                  onClick={onMoreBtnClick}
                  buttonSize={"small"}
                  fontSize={"xsForMinorText"}
                />
              </div>
            )}
            {/* {profileType === "others" && (
              <div style={css.textLine}>
                <RelationTypographyXL color="secondary">
                  <GenderLocationInfoText gender={gender} location={location} />
                </RelationTypographyXL>
              </div>
            )} */}
            {profileType === "demo" && (
              <div style={css.textLine}>
                {/* <RelationTypographyXL color="secondary">
                  <GenderLocationInfoText gender={gender} location={location} />
                </RelationTypographyXL>{" "} */}
                <RelationTypographyXL color="secondary">
                  <FollowCountText type="following" number={followingNum} />
                </RelationTypographyXL>
              </div>
            )}
            <div style={css.username}>
              <OwnerNameTypographyXL variant="h4">
                {ownerName}
              </OwnerNameTypographyXL>
            </div>
            <div style={css.buttonRow}>
              {firstBtnText && (
                <div>
                  <ContainedCommonButtonView
                    onClick={onFirstBtnClick}
                    design={firstBtnStyle}
                    disabled={disabledFirstBtn}
                  >
                    {firstBtnText}
                  </ContainedCommonButtonView>
                </div>
              )}
              {secondBtnText && (
                <div style={css.secondBtn}>
                  <ContainedCommonButtonView
                    onClick={onSecondBtnClick}
                    design={secondBtnStyle}
                    disabled={disabledSecondBtn}
                  >
                    {secondBtnText}
                  </ContainedCommonButtonView>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return getDeviceType() === "mobile" ? mobileLayout() : desktopLayout();
}

export default ProfileUnitView;
